import type { FC } from 'react';
import React from 'react';
import { Link, ListItem, ListItemText } from '@mui/material';
import { Trans } from 'next-i18next';

type PlatformsListItemProps = {
  icon: number;
  text: string;
  linkUrl: string;
  translateKey: string;
};

export const PlatformsListItem: FC<PlatformsListItemProps> = ({ icon, text, linkUrl, translateKey }) => (
  <ListItem alignItems="flex-start">
    <div className="page-403__icon">{icon}</div>
    <ListItemText className="page-403__list-text">
      <Trans i18nKey={translateKey}>
        {text}
        <Link color="primary" target="_blank" href={linkUrl} />
      </Trans>
    </ListItemText>
  </ListItem>
);
